/* eslint-disable no-undef */
import Glide from '../vendors/glide.min';

const MOBILE_MAX = 767;

const asFeaturedCarousels = () => {
  const carousels = document.querySelectorAll('.as-featured__carousel:not([data-favorites-carousel])');
  if (carousels.length === 0) {
    return;
  }

  const instances = [];

  [].forEach.call(carousels, (element) => {
    const slideCount = element.querySelectorAll('.as-featured__featured-item').length;
    instances.push({
      element,
      glideRef: null,
      slideCount,
    });
  });

  const shouldEnable = instance => (
    window.innerWidth <= MOBILE_MAX && instance.slideCount > 1
  );

  const mount = (instance) => {
    if (instance.glideRef || !shouldEnable(instance)) {
      return;
    }
    const options = {
      autoplay: false,
      gap: 0,
      perView: 1,
      startAt: 0,
      type: 'carousel',
    };
    const peek = parseInt(instance.element.getAttribute('data-glide-peek'), 10);
    if (peek > 0) {
      options.gap = 12;
      options.peek = { before: 0, after: peek };
    }
    instance.glideRef = new Glide(instance.element, options);
    instance.glideRef.mount();
  };

  const destroy = (instance) => {
    if (!instance.glideRef) {
      return;
    }
    instance.glideRef.destroy();
    instance.glideRef = null;
  };

  const sync = () => {
    instances.forEach((instance) => {
      if (shouldEnable(instance)) {
        mount(instance);
      } else {
        destroy(instance);
      }
    });
  };

  sync();
  window.addEventListener('resize', sync);
};

export default asFeaturedCarousels;
/* eslint-enable no-undef */
